module.exports = __webpack_public_path__ + "img/sslc.7128436f.png";